import { useEffect, useState } from 'react';

type Theme = 'light' | 'light-contrast' | 'dark-tech';

const THEME_KEY = 'ucas-theme';

export function useTheme() {
  const [theme, setTheme] = useState<Theme>(() => {
    if (typeof window !== 'undefined') {
      return (localStorage.getItem(THEME_KEY) as Theme) || 'dark-tech';
    }
    return 'dark-tech';
  });

  useEffect(() => {
    const root = window.document.documentElement;
    if (theme === 'light') {
      root.removeAttribute('data-theme');
    } else {
      root.setAttribute('data-theme', theme);
    }
    localStorage.setItem(THEME_KEY, theme);
  }, [theme]);

  return { theme, setTheme };
}
